import Vue from "vue"
import VueI18n from "vue-i18n"
import getLocale from "@/utils/locale"
import CustomBgHeroSection from "@/features/custom-bg-hero-section/components/custom-bg-hero-section"

Vue.use(VueI18n)

const container = document.querySelector(".vue-custom-bg-hero-section")

if (container) {
  const { headline, subheadline } = container.dataset

  new Vue({
    name: "CustomBgHeroSectionInit",
    el: container,
    i18n: new VueI18n({ locale: getLocale() }),
    render: (h) =>
      h(CustomBgHeroSection, {
        props: {
          headline,
          subheadline
        }
      })
  })
}
